import * as React from "react";
const SvgFiRrHotdog = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hotdog_svg__a)">
      <path
        fill="#062147"
        d="M23.044 12.9c3.077-3.35-1.8-8.01-5.046-4.851-2.533 2.553-9.457 2.541-11.982.015-4.236-3.652-8.827 2.888-3.811 5.9a4.43 4.43 0 0 0-.95 4.536C2.435 21.775 7.684 22.9 12 23c4.328-.107 9.553-1.218 10.744-4.5a4.43 4.43 0 0 0-.95-4.53q.67-.483 1.25-1.07m-2.186 4.927a2.5 2.5 0 0 1-1.278 1.424A16.3 16.3 0 0 1 12 21c-3.693-.071-10.371-1.25-8.755-5.079a2.506 2.506 0 0 1 3.335-1.176A11.36 11.36 0 0 0 12 16a11.36 11.36 0 0 0 5.42-1.255 2.516 2.516 0 0 1 3.438 3.086zm.73-6.3c-.48.466-1.009.88-1.577 1.234C16.96 11.714 15.56 14.24 12 14c-3.557.241-4.966-2.286-8.012-1.234a9.4 9.4 0 0 1-1.578-1.235A1.5 1.5 0 0 1 2 10.458a1.51 1.51 0 0 1 2.594-.984c3.43 3.416 11.62 3.224 14.819-.007a1.5 1.5 0 0 1 2.176 2.065zM11 5V2a1 1 0 1 1 2 0v3a1 1 0 0 1-2 0m4-1V2a1 1 0 1 1 2 0v2a1 1 0 0 1-2 0m-8-.011V2a1 1 0 0 1 2 0v1.989a1 1 0 0 1-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hotdog_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHotdog;
